import { render } from "./VTextarea.vue?vue&type=template&id=a66222b0"
import script from "./VTextarea.vue?vue&type=script&lang=js"
export * from "./VTextarea.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__